export enum BusinessPartnerProfileOwnerManagementRoutes {
  List = '',
  Register = 'register',
  Details = ':partnerProfileOwnerId',
}
